import { ACCESS_TOKEN_COOKIE_KEY, REFRESH_TOKEN_COOKIE_KEY, ACCESS_TOKEN_EXPIRATION_COOKIE_KEY } from "@montana/constants/cookie";
import { getCookieItem, setCookieItem, removeCookieItem } from "./browser-cookie.helper";
import { ILoginResponse } from "@montana/containers/authentication/authentication.sagas";
import { getSessionStorageItem, setSessionStorageItem, removeSessionStorageItem } from "./sessionstorage.helper";
import { isBrowser } from '@montana/helpers/browser.helper';

const NINETY_DAYS_IN_MS = 7776000000;

function getItem(key: string): string | null | undefined {
    return getCookieItem(ACCESS_TOKEN_COOKIE_KEY) ? getCookieItem(key) : getSessionStorageItem(key);
}

function setItem(key: string, value: string, asCookie?: boolean): boolean | undefined | void {
    return asCookie || getCookieItem(ACCESS_TOKEN_COOKIE_KEY) ? setCookieItem(key, value, `${new Date(Date.now() + NINETY_DAYS_IN_MS).toUTCString()}`) : setSessionStorageItem(key, value);
}

function removeItem(key: string): void {
    removeCookieItem(key);
    removeSessionStorageItem(key);
}

export function getAccessToken(): string | null | undefined {
    return getItem(ACCESS_TOKEN_COOKIE_KEY);
}

export function getRefreshToken(): string | null | undefined {
    return getItem(REFRESH_TOKEN_COOKIE_KEY);
}

export function setToken(authResponse: ILoginResponse, saveAsCookie?: boolean): void {
    const accessToken = authResponse.access_token;
    const expiresIn = authResponse.expires_in;
    const refreshToken = authResponse.refresh_token;
    if (accessToken) {
        const existingCookieToken = getAccessToken();

        if (accessToken === existingCookieToken) {
            return;
        }

        setItem(ACCESS_TOKEN_COOKIE_KEY, accessToken, saveAsCookie);
        setItem(ACCESS_TOKEN_EXPIRATION_COOKIE_KEY, `${Date.now() + expiresIn}`, saveAsCookie);
    }
    if (refreshToken) {
        const existingCookieToken = getRefreshToken();

        if (refreshToken === existingCookieToken) {
            return;
        }

        setItem(REFRESH_TOKEN_COOKIE_KEY, refreshToken, saveAsCookie);
    }
}

export function getToken(): string | null | undefined {
    if (isBrowser) {
        return getAccessToken();
    }
}

export function deleteTokens(): void {
    removeItem(ACCESS_TOKEN_COOKIE_KEY);
    removeItem(ACCESS_TOKEN_EXPIRATION_COOKIE_KEY);
    removeItem(REFRESH_TOKEN_COOKIE_KEY);
}
